<template>
    <div class="alert-final">
        <div class="alert-final-container">
            <div class="image-alert">
                <img class="image" src="../../assets/decode-correct.png" alt="">
            </div>
            <div class="text-alert">
                <div class="title-alert">{{$t("components.Alerts.AlertFinal.title")}}</div>
                <div class="sub-title-alert">{{$t("components.Alerts.AlertFinal.subtitle")}}</div>
            </div>
            <div class="button-alert" @click="goDash()">
                <button-default name="suggestion" classButton="game" :textButton='$t("components.Alerts.AlertFinal.textButton")'></button-default>
            </div>
        </div>
    </div>
</template>
<script>
import ButtonDefault from '../Buttons/ButtonDefault.vue'
export default {
    components : {
        ButtonDefault
    },
    methods : {
        goDash(){
            this.$router.push('/dashboard')
        }
    }
}
</script>
<style lang="scss" scoped>
    .alert-final{
        width: 100%;
        height: 100vh;
        background: rgb(155,254,248);
        background: linear-gradient(0deg, rgba(155,254,248,1) 0%, rgba(61,240,229,1) 100%);

        .alert-final-container{

            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .image-alert{
                height: 20%;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: flex-end;

                .image{
                    height: 120px;
                }
            }

            .text-alert{
                height: 20%;
                width: 80%;
                margin: 8% 0 4%;
                text-align: center;

                .title-alert{
                    font-size: 20px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
            }

            .button-alert{
                height: 10%;
                width: 50%;
                margin-top: 5%;
            }
        }
    }

    @media only screen and (min-width: 750px){
        .alert-final{
            height: 100%;
        }
    }
</style>
